import { createContext } from 'react';

const SponsoredProductsContext = createContext();

export const { Provider, Consumer } = SponsoredProductsContext;

export default SponsoredProductsContext;
